import React from 'react'
import {Provider} from 'react-redux'
import {initStore} from './redux/initStore'
import {PublicEmbed, PublicEmbedContainer} from './PublicEmbed'

const store = initStore()

export class PublicEmbedApp extends React.PureComponent {
  static propTypes = PublicEmbed.propTypes

  render () {
    return (
      <Provider store={store}>
        <PublicEmbedContainer {...this.props} />
      </Provider>
    )
  }
}
